import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { AssetFinanceUrl } from "../../../../config";
import Form from "./form";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import Joyride from "react-joyride";
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = AssetFinanceUrl.uri;

const tourSteps = [
  {
    target: ".dynamic-table-header",
    content: "Manage car models, makes, asset types, and base indicative values.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find car models by make, model name, or code.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Car Model.",
    placement: "right",
  },
];

const CarModelsTable = () => {
  const [runTour, setRunTour] = useState(false);

  const handleToggle = async (row, field, currentValue, label, refetch) => {
    const confirm = await Swal.fire({
      title: `${currentValue ? "Deactivate" : "Activate"} ${label}?`,
      text: `Are you sure you want to ${currentValue ? "disable" : "enable"} "${label}" for "${row.Make} ${row.ModelName}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;

    const response = await executeAnyMutation(
      "updateCarModel",
      {
        id: row.Id,
        code: row.Code,
        make: row.Make,
        modelName: row.ModelName,
        companyId: row.CompanyId,
        [field]: !currentValue,
      },
      "carModel",
      false,
      base_url
    );

    if (response?.results) {
      await Swal.fire("Done!", `${label} has been ${!currentValue ? "enabled" : "disabled"}.`, "success");
      if (refetch) refetch();
    } else {
      await Swal.fire("Error!", "Could not update the car model. Please try again.", "error");
    }
  };

  const actions = {
    entity: localStorage.getItem("SelectedTabLabel") || "Car Models",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    toggleActive: {
      key: "TOGGLE_ACTIVE",
      button_name: (row) => (row?.IsActive ? "Deactivate" : "Activate"),
      Show_Button: true,
      permission: "EditPermission",
      onClick: (row, refetch) => handleToggle(row, "isActive", row?.IsActive, "Active Status", refetch),
    },
    dataObject: {
      ignoreFields: [
        "CreatedAt",
        "CreatedBy",
        "UpdatedAt",
        "UpdatedBy",
        "CompanyId",
        "EngineCapacityCc",
        "engineCapacityCc",
        "EngineCapacity",
        "engineCapacity",
        "EngineCapacityCC",
        "engineCapacityCC",
      ],
      objectName: "allCarModels",
      parameters: "",
    },
    isSubRight: true,
    showStatus: true,
    showMore: {
      search: false,
      min: 0,
      max: 0
    }
  };

  return (
    <Box m="20px">
      <Joyride
        steps={tourSteps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      <DynamicTableForJson
        title="Car Models Management"
        subtitle="Manage Vehicle Makes, Models, Asset Types & Indicative Values"
        FormComponent={Form}
        actions={actions}
        base_url={base_url}
        tourSteps={tourSteps}
      />
    </Box>
  );
};

export default CarModelsTable;
